export const LANDSCAPE_PAGES = ['player', 'learn', 'module/', 'ambitus'];

export const OUT_OF_APP_AUTHORIZED_PAGES = [
  'auth',
  'subscribe', 
  'login',
  'signup',
  'signup-confirm',
  'password',
  'account-deleted',
  'partition',
];

export function isLandscapePage(path: string): boolean {
  return LANDSCAPE_PAGES.some((value) => path.includes(value));
}

export function isOutOfAppAuthorizedPage(path: string): boolean {
  return OUT_OF_APP_AUTHORIZED_PAGES.some((value) => path.includes(value));
} 